import { render, staticRenderFns } from "./TailwindProgressBar.vue?vue&type=template&id=265b0b5e&scoped=true&"
import script from "./TailwindProgressBar.vue?vue&type=script&lang=js&"
export * from "./TailwindProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./TailwindProgressBar.vue?vue&type=style&index=0&id=265b0b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265b0b5e",
  null
  
)

export default component.exports